// transfers
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import WebbSpinner from "../webb/webb-spinner-sm";
import WebbSpinText from "../webb/webb-spintext";
import ListNoData from "../webb/list-nodata";

import { UserForm } from "../../services/srvc-utilities";
import { GetLocalUser, GetLocalBusiness } from "../../services/srvc-auth-user";
import { GetEventsInfo } from "../../services/srvc-events-realm";


export default function EventsViewModule() {

  const asset = UserForm() === 'in' ? GetLocalUser() : GetLocalBusiness();

  const {id} = useParams()
  const [loading, setLoading] = useState(true);

  const [data, setData] = useState([]);

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        
       const datx = await GetEventsInfo({
         data: {enid: id},
         user: asset.usid
       })
      setData(datx.data)
      setLoading(false)
      }
      fetchData()
    } else {}
  },[asset.usid, id]);


  if (loading){ return ( <> <div className="text-center"><WebbSpinner /></div> </> ) }

  return (
  <>
    {console.log(data)}
    <div className="media-square mb-3">
      <img src={data.link} className='img-fluid rounded-wd' alt="..."></img>
    </div>

    <div className="">
      <h2 className="fw-bold lead text-color-main">{data.name}</h2>
      <p className="text-">{data.memo}</p>
    </div>

  </>
  )
}